import { useContext } from "react";
import { ToasterContext } from "../context/ToasterContext";

/*
  Usage:
    const { showToast } = useToaster();
    showToast(message, severity, isOpen, autoClose);
    severity = "success" | "info" | "warning" | "error"
*/
const useToaster = () => {
  const { setToaster } = useContext(ToasterContext);

  const showToast = (message, severity, isOpen, autoClose) => {
    setToaster({
      isOpen,
      message,
      severity,
      autoClose: autoClose === undefined ? true : autoClose,
    });
  };

  return { showToast };
};

export default useToaster;
